/**
 * @file Contains the definition of maps help with file generator
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import comment from './Lin21Update1GeneratorComment';

/**
 * Mapping prefix text to state
 * The key is prefix text for each variable in Options_Update1.txt file
 * The value is the state name
 * @type {Map}
 */

export const state2PrefixMap = new Map([
    ['installInstance', 'install.Instance='],
    ['installOperation', 'install.Operation='],
]);

/**
 * Mapping the comments that should appear before each prefix text
 * The key is prefix text for each variable in Options_Update1.txt file
 * The value is the comments content
 * @type {Map}
 */

export const state2CommentMap = new Map([
    ['installInstance', comment.installInstance],
    ['installOperation', comment.installOperation],
]);
